import React, { useState, useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { ImageSearchContext } from '../../components/ImageSearchQueryContext';
import ImageSearchQueryParams from './imageSearchQueryParams'
import ImageSearchResult from './imageSearchResult'
import ImageSearchDailyResult from './imageSearchDailyResult'
import ImageSearchBatchRecords from './imageSearchBatchRecords';
import CloseIcon from '@mui/icons-material/Close';
import SearchQueryDetails from './searchQueryDetails';

const defaultSearch = {
    accountNumber: null,
    lockboxNumber: null,
    lockboxSite: null,
    processedDateFrom: null,
    processedDateTo: null,
    batchNumberFrom: null,
    batchNumberTo: null,
    batchAmountFrom: null,
    batchAmountTo: null,
    checkNumberFrom: null,
    checkNumberTo: null,
    amountFrom: null,
    amountTo: null,
    abaRoutingNumber: null,
    checkingAccountNumber: null,
    customerIdentifier: null,
    payeeName: null,
    invoiceNumber: null,
    defaultSearch: false
}
const ImageSearch = () => {
    const { setSearchQueryContext, setScreen, screen, searchQueryContext } = useContext(ImageSearchContext);
    const [searchQuery, setSearchQuery] = useState({
        ...defaultSearch
    });
    const [searchQueryResponse, setSearchQueryResponse] = useState(null)

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === "processedDateRange"){
            setSearchQuery({
                ...searchQuery,
                processedDateFrom: e?.target?.selectedDates[0]?.toISOString() ?? "",
                processedDateTo: e?.target?.selectedDates[1]?.toISOString() ?? "",
            })
        } else {
            setSearchQuery({
                ...searchQuery,
                [name]: value
            })
        }
       
    }

    const handleClearSearch = () => {
        setSearchQuery({
            ...defaultSearch
        })
        setSearchQueryContext(defaultSearch);
        setScreen(1)
    }

    const handleSearch = () => {
        setSearchQueryContext(searchQuery);
        fetchSearchData()
    }

    const fetchSearchData = async () => {
        try {
             const processedDateRange = searchQuery.processedDateRange
             const searchQueryParam = {processedDateRange, ...searchQuery}
             const response = await fetch('https://demo-api.incedopay.com/api/sso-service/search-summary', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify( searchQueryParam ),
             });

            const data = await response.json();
            //const data = {
            //    "records": [
            //        {
            //            "accountNumber": "3243243244",
            //            "processedDate": "2025-01-01T00:00:00",
            //            "lockboxSite": "Site1",
            //            "lockboxNumber": "643",
            //            "currency": "USD",
            //            "totalItems": 2,
            //            "totalAmount": 100
            //        },
            //        {
            //            "accountNumber": "3243243245",
            //            "processedDate": "2025-01-02T00:00:00",
            //            "lockboxSite": "Site2",
            //            "lockboxNumber": "644",
            //            "currency": "USD",
            //            "totalItems": 2,
            //            "totalAmount": 200
            //        },
            //        {
            //            "accountNumber": "3243243246",
            //            "processedDate": "2025-01-03T00:00:00",
            //            "lockboxSite": "Site3",
            //            "lockboxNumber": "645",
            //            "currency": "USD",
            //            "totalItems": 2,
            //            "totalAmount": 300
            //        },
            //        {
            //            "accountNumber": "3243243247",
            //            "processedDate": "2025-01-04T00:00:00",
            //            "lockboxSite": "Site4",
            //            "lockboxNumber": "646",
            //            "currency": "USD",
            //            "totalItems": 2,
            //            "totalAmount": 400
            //        },
            //        {
            //            "accountNumber": "3243243248",
            //            "processedDate": "2025-01-05T00:00:00",
            //            "lockboxSite": "Site5",
            //            "lockboxNumber": "647",
            //            "currency": "USD",
            //            "totalItems": 2,
            //            "totalAmount": 500
            //        }
            //    ],
            //    "totalRecords": 11,
            //    "pageNumber": 1,
            //    "pageSize": 5
            //}
            console.log('Response:', data);
            setSearchQueryResponse(data)
            setScreen(2)
        } catch (err) {
            console.error('Fetch error:', err);
        }
    }

    const fetchDailyDetails = async() => {
        // Fetch daily details based on the selected row's account number
        // Implement the API call here to fetch daily details
        try {
             const response = await fetch('https://demo-api.incedopay.com/api/sso-service/batch-summary', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify( searchQueryContext ),
             });

            const data = await response.json();
    //        const data = {
    //            "batchSummary": {
    //                "batchNumber": "123",
    //                "accountNumber": "3243243244",
    //                "lockboxSite": "Site1",
    //                "lockboxNumber": "643",
    //                "currency": "USD",
    //                "processedDate": "2025-01-01T00:00:00",
    //                "totalItems": 20,
    //                "totalAmount": 200
    //            },
    //            "batches": [
    //                {
    //                    "batchNumber": "123",
    //                    "totalItems": 20,
    //                    "totalAmount": 200
    //                },
    //                {
    //                    "batchNumber": "124",
    //                    "totalItems": 10,
    //                    "totalAmount": 100
    //                }
    //            ]
    //        }
            console.log('Response:', data);
            setSearchQueryResponse(data)
            setSearchQueryContext({...searchQueryContext, ...data.batchSummary})
            setScreen(3)
        } catch (err) {
            console.error('Fetch error:', err);
        }
    }

    const fetchBatchRecords = async() => {
        try {
             const response = await fetch('https://demo-api.incedopay.com/api/sso-service/batch-records', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify( searchQueryContext ),
             });

            const data = await response.json();
    //        const data = {
    //            "transactions": [
    //                {
    //                    "transactionID": "TRAN0132434",
    //                    "numberOfDocuments": 4,
    //                    "checkAmount": 50,
    //                    "numberOfNotations": 2,
    //                    "payeeName": "John Smith",
    //                    "currency": "USD",
    //                    "checkNumber": "C01324222",
    //                    "customerIdentifier": "Cust1234",
    //                    "invoiceNumber": "Inv000231",
    //                    "id": 1
    //                },
    //                {
    //                    "transactionID": "TRAN0132434",
    //                    "numberOfDocuments": 4,
    //                    "checkAmount": 50,
    //                    "numberOfNotations": 2,
    //                    "payeeName": "John Smith",
    //                    "currency": "USD",
    //                    "checkNumber": "C01324222",
    //                    "customerIdentifier": "Cust1234",
    //                    "invoiceNumber": "Inv000231",
    //                    "id": 12
    //                }
    //            ]
    //        }
            console.log('Response:', data);
            setSearchQueryResponse(data)
            setScreen(4)
        } catch (err) {
            console.error('Fetch batch error:', err);
        }
    }

    const handlePrintPdf = () => {
        console.log("print pdf")
    }

    const renderScreens = () => {
        switch (screen) {
            case 1:
                return <ImageSearchQueryParams handleClearSearch={handleClearSearch} handleSearch={handleSearch} searchQuery={searchQuery} handleChange={handleChange} />;
            case 2:
                return <ImageSearchResult searchQueryResponse={searchQueryResponse} fetchDailyDetails={fetchDailyDetails} />
            case 3:
                return <ImageSearchDailyResult searchQueryResponse={searchQueryResponse} fetchBatchRecords={fetchBatchRecords} handlePrintPdf={handlePrintPdf} />
            case 4:
                return <ImageSearchBatchRecords searchQueryResponse={searchQueryResponse} handlePrintPdf={handlePrintPdf}/>
            default:
                return null;
        }
    }

    return <>
        <Grid container sx={{ padding: '32px', paddingTop: '16px', paddingBottom: '0px' }}>
            <Grid container display={'flex'} flexDirection={'column'} width={'100%'}>
                <Grid container flexDirection={'row'} justifyContent={'space-between'} width={'100%'}>
                    <Grid item>
                        <Typography sx={{ color: '#5563BE', fontSize: '24px', fontWeight: 500, lineHeight: '28px' }}>
                            {screen === 1 || screen === 2 ? "Lockbox  Activity & Image Inquiry Criteria" : "Daily Details"}
                        </Typography>
                    </Grid>
                    {(screen === 3 || screen === 4) && <Grid item display={'flex'} alignItems={'center'}>
                        <CloseIcon sx={{cursor: 'pointer'}} fontSize='small' onClick={handleClearSearch} />
                    </Grid>}
                </Grid>

                {screen === 1 || screen === 2 ? <Grid item xs={12} sx={{ color: '#4C4C4C', fontSize: '14px', fontWeight: 400, marginTop: '8px' }}>
                    <Typography>
                        {screen === 1 ? "Please select one of the following criteria" : screen === 2 ? "Search Results" : ""}
                    </Typography>
                </Grid> : null}
            </Grid>
        </Grid>
        {screen!==1 && <SearchQueryDetails />}
        {renderScreens()}
    </>
}

export default ImageSearch;